import { useRef, useMemo } from "react";

import { Box, Tooltip, Typography } from "@mui/material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { PlayerCard, PlayerCardRef } from "features/videoPlayer/PlayerCard";
import { playbackDebugSelectors } from "./store/selectors.debug";
import { Stack } from "@mui/material";
import { useAppSelector } from "app/hooks";
import { PlayerCardStatus } from "features/videoPlayer/PlayerCardStatus";
import VideocamOff from "@mui/icons-material/VideocamOff";

export interface RecordingPlayerProps {
    dossierDeviceName: string;
    tooltipText: string | undefined;
    hidden: boolean;
}

export function EmptyRecordingPlayer(props: RecordingPlayerProps) {
    // the player card
    const playerCardRef = useRef<PlayerCardRef>(null);
    const debugShowBufferingRecordings = useAppSelector(
        playbackDebugSelectors.selectShowBufferingRecordings,
    );
    const debugShowRecordingsOutsidePlaybackAndBufferingWindow = useAppSelector(
        playbackDebugSelectors.selectShowRecordingsOutsidePlaybackAndBufferingWindow,
    );

    const visible = useMemo(() => {
        return (
            !props.hidden ||
            debugShowRecordingsOutsidePlaybackAndBufferingWindow ||
            debugShowBufferingRecordings
        );
    }, [
        props.hidden,
        debugShowRecordingsOutsidePlaybackAndBufferingWindow,
        debugShowBufferingRecordings,
    ]);

    return (
        <>
            <Box
                sx={{
                    display: visible ? "block" : "none",
                }}
            >
                <PlayerCard
                    ref={playerCardRef}
                    cardActions={
                        <>
                            <Tooltip
                                title={props.tooltipText}
                                slotProps={{
                                    popper: {
                                        container: playerCardRef.current?.root,
                                    },
                                }}
                            >
                                <AccessTimeIcon sx={{ marginLeft: 2 }} />
                            </Tooltip>

                            <Stack
                                justifyContent={"center"}
                                direction="row"
                                spacing={2}
                                sx={{ flexGrow: 1 }}
                            >
                                <Typography
                                    variant="body2"
                                    fontWeight="bold"
                                >
                                    {props.dossierDeviceName}
                                </Typography>
                            </Stack>
                        </>
                    }
                >
                    <PlayerCardStatus
                        mode={"status"}
                        statusIcon={<VideocamOff sx={{ fontSize: 100 }} />}
                        statusMessage={"No recording available"}
                    />
                </PlayerCard>
            </Box>
        </>
    );
}
